/* tslint:disable */
/* eslint-disable */
/**
 * Toki Public APIs
 * API Gateway for all Toki Public APIs
 *
 * The version of the OpenAPI document: 4.8.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { GetAnnexURLV1200ResponseFromJSON, GetAnnexesOfContractV1200ResponseFromJSON, } from '../models/index';
/**
 *
 */
export class AnnexApi extends runtime.BaseAPI {
    /**
     * Get Annex URL
     * Get Annex URL
     */
    async getAnnexURLV1Raw(requestParameters, initOverrides) {
        if (requestParameters['contractNumber'] == null) {
            throw new runtime.RequiredError('contractNumber', 'Required parameter "contractNumber" was null or undefined when calling getAnnexURLV1().');
        }
        if (requestParameters['annexNumber'] == null) {
            throw new runtime.RequiredError('annexNumber', 'Required parameter "annexNumber" was null or undefined when calling getAnnexURLV1().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("firebase", []);
        }
        const response = await this.request({
            path: `/v1/annexes/{contract_number}/{annex_number}`.replace(`{${"contract_number"}}`, encodeURIComponent(String(requestParameters['contractNumber']))).replace(`{${"annex_number"}}`, encodeURIComponent(String(requestParameters['annexNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetAnnexURLV1200ResponseFromJSON(jsonValue));
    }
    /**
     * Get Annex URL
     * Get Annex URL
     */
    async getAnnexURLV1(requestParameters, initOverrides) {
        const response = await this.getAnnexURLV1Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List of all annexes of a contract
     */
    async getAnnexesOfContractV1Raw(requestParameters, initOverrides) {
        if (requestParameters['contractNumber'] == null) {
            throw new runtime.RequiredError('contractNumber', 'Required parameter "contractNumber" was null or undefined when calling getAnnexesOfContractV1().');
        }
        const queryParameters = {};
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }
        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("firebase", []);
        }
        const response = await this.request({
            path: `/v1/contracts/{contract_number}/annexes`.replace(`{${"contract_number"}}`, encodeURIComponent(String(requestParameters['contractNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetAnnexesOfContractV1200ResponseFromJSON(jsonValue));
    }
    /**
     * List of all annexes of a contract
     */
    async getAnnexesOfContractV1(requestParameters, initOverrides) {
        const response = await this.getAnnexesOfContractV1Raw(requestParameters, initOverrides);
        return await response.value();
    }
}
